import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-update-pricelists',
  templateUrl: './update-pricelists.component.html',
  styleUrls: ['./update-pricelists.component.scss']
})
export class UpdatePricelistsComponent  extends FeaturesBaseComponent implements OnInit, OnDestroy {

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(){
    super.ngOnDestroy()
  }
}
